/**
 * @file   : SimpleHero.js
 * @author : Amarjeet Lamba (Amarjeet.Lamba@AspiraConnect.com)
 * @date   : 1/29/2019, 2:47:40 PM
 */
import PropTypes from 'prop-types'
import React from 'react'

import Cont from '../../../external/components/layout/Cont'
import { isEmpty } from '../../../external/utilities/GeneralUtils'

const SimpleHero = ({
  imageURL = null,
  imageClass = null,
  title = null,
  headerContent = null,
  children,
}) => {
  const getStyle = function () {
    let imgStyle = null
    if (!isEmpty(imageURL)) {
      imgStyle = { backgroundImage: `url(${imageURL})` }
    }

    return imgStyle
  }

  const getImageClass = function () {
    if (isEmpty(imageClass)) {
      return ''
    }

    return ` ${imageClass}`
  }

  const getTitle = function () {
    let imgTitle = null
    if (!isEmpty(title)) {
      imgTitle = title
    }

    return imgTitle
  }

  const getHeaderContentUI = function () {
    if (!isEmpty(headerContent)) {
      return (
        <Cont asContainer>
          <div className="simple-hero-header">{headerContent}</div>
        </Cont>
      )
    }

    return null
  }

  return (
    <div
      className={`simple-hero${getImageClass()}`}
      style={getStyle()}
      title={getTitle()}
    >
      {getHeaderContentUI()}
      {children}
    </div>
  )
}

SimpleHero.propTypes = {
  imageURL: PropTypes.string,
  imageClass: PropTypes.string,
  title: PropTypes.string,
  headerContent: PropTypes.node,
  children: PropTypes.node,
}

export default SimpleHero
